// src/api/salidaHerramienta.js
import { apiFetch } from './index.js';

const API_BASE = '/api/SalidaHerramienta';

/**
 * Obtener todos los registros de salida de herramienta
 * @returns {Promise} Lista de salidas
 */
export const obtenerSalidasHerramienta = async () => {
  try {
    const response = await apiFetch(API_BASE);
    return response.success ? response : { success: true, data: response };
  } catch (error) {
    console.error('Error al obtener salidas de herramienta:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener una salida de herramienta por ID
 * @param {number} id - ID de la salida
 * @returns {Promise} Datos de la salida
 */
export const obtenerSalidaHerramientaPorId = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}`);
    return response.success ? response : { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener salida de herramienta ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Crear una nueva salida de herramienta
 * @param {Object} salidaData - Datos de la salida
 * @returns {Promise} Registro creado
 */
export const crearSalidaHerramienta = async (salidaData) => {
  try {
    const response = await apiFetch(API_BASE, {
      method: 'POST',
      body: JSON.stringify(salidaData)
    });
    return response.success ? response : { success: true, data: response };
  } catch (error) {
    console.error('Error al crear salida de herramienta:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Actualizar una salida de herramienta
 * @param {number} id - ID de la salida
 * @param {Object} salidaData - Datos actualizados
 * @returns {Promise} Registro actualizado
 */
export const actualizarSalidaHerramienta = async (id, salidaData) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(salidaData)
    });
    return response.success ? response : { success: true, data: response };
  } catch (error) {
    console.error(`Error al actualizar salida de herramienta ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Eliminar una salida de herramienta
 * @param {number} id - ID de la salida
 * @returns {Promise} Resultado de la eliminación
 */
export const eliminarSalidaHerramienta = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}`, {
      method: 'DELETE'
    });
    return response.success ? response : { success: true, data: response };
  } catch (error) {
    console.error(`Error al eliminar salida de herramienta ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener salidas de herramienta por estado
 * @param {string} estado - Estado de la salida
 * @returns {Promise} Lista de salidas
 */
export const obtenerSalidasPorEstado = async (estado) => {
  try {
    const response = await apiFetch(`${API_BASE}/estado/${estado}`);
    return response.success ? response : { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener salidas por estado ${estado}:`, error);
    return { success: false, error: error.message };
  }
};
